import {
  Component,
  OnInit,
  OnDestroy,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthModule, AuthService } from '@auth0/auth0-angular';
import { Router, RouterModule } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { envs } from '../data/env.data';

@Component({
  selector: 'app-callback',
  standalone: true,
  imports: [CommonModule, AuthModule, RouterModule],
  providers: [AuthService],
  templateUrl: './callback.component.html',
  styleUrl: './callback.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallbackComponent implements OnInit, OnDestroy {
  private readonly router = inject(Router);
  private readonly auth = inject(AuthService);
  private readonly destroy$ = new Subject<void>();

  private readonly DEFAULT_REDIRECT_URL = '/';
  private readonly DEFAULT_BANNER_REDIRECT_URL = '/';

  ngOnInit(): void {
    this.handleAuthCallback();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private handleAuthCallback(): void {
    this.auth.appState$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (appState) => {
        this.navigateToTarget(appState?.target);
      },
      error: (err) => {
        console.error('Error during authentication callback:', err);
        this.navigateToTarget();
      },
    });
  }

  private navigateToTarget(target?: string): void {
    const redirectUrl =
      target ||
      (envs.useParamsForBanner
        ? this.DEFAULT_BANNER_REDIRECT_URL
        : this.DEFAULT_REDIRECT_URL);
    this.router.navigateByUrl(redirectUrl);
  }
}
